module.exports = __webpack_public_path__ + "img/page-27.ab437fee.jpg";